
export enum DropdownModeEnum {
    MULTIPLE = 'multiple',
    TAGS = 'tags'
}
